import { HabitSchedule } from '@griply/types';

import { getScheduleEndDate } from './get-schedule-end-date';
import { isDegenerateSchedule } from './is-degenerate-schedule';

// Lower bound of a schedule's governed window: the end of the nearest earlier sibling that governs any days at all.
export const getPrecedingScheduleEndDate = (
  sortedSchedules: Pick<HabitSchedule, 'startDate' | 'endDate'>[],
  index: number,
) => {
  const precedingSchedule = sortedSchedules
    .slice(0, index)
    .reverse()
    .find((schedule) => !isDegenerateSchedule(schedule));
  return getScheduleEndDate(precedingSchedule);
};
